import { LitElement, html, nothing } from 'lit';
import { currentLang } from '../i18n';
import type { WorkListAction } from './work-list';
import { defineZenComponent } from './register';

export type WorkAchievement = {
  goalId: string;
  title: string;
  /** 「今日 N 件目の完了です」, in the user's time zone. */
  count: string;
  next: { goalId: string; key: string; title: string } | null;
};

/** #2749: the card above the list when a goal is completed, in place of confetti. */
export class ZenWorkAchievement extends LitElement {
  static properties = {
    achievement: { attribute: false },
  };

  declare achievement: WorkAchievement | null;

  constructor() {
    super();
    this.achievement = null;
  }

  createRenderRoot() {
    return this;
  }

  private emit(detail: WorkListAction) {
    this.dispatchEvent(new CustomEvent<WorkListAction>('work-list-action', { detail, bubbles: true, composed: true }));
  }

  render() {
    const a = this.achievement;
    if (!a) return nothing;
    const en = currentLang === 'en';
    const close = en ? 'Close' : '閉じる';
    return html`<div class="work-achievement" role="status" @keydown=${(e: KeyboardEvent) => { if (e.key === 'Escape') this.emit({ action: 'achievement-close' }); }}>
      <span class="work-achievement-check" aria-hidden="true"><span class="mi">check_circle</span></span>
      <div class="work-achievement-body">
        <strong class="work-achievement-head">${en ? 'Well done' : 'おつかれさまでした'}</strong>
        <span class="work-achievement-title">${en ? `Completed "${a.title}"` : `「${a.title}」を完了しました`}</span>
        ${a.count ? html`<span class="work-achievement-count">${a.count}</span>` : nothing}
        ${a.next ? html`<button type="button" class="work-achievement-next" @click=${() => this.emit({ action: 'open', key: a.next!.key })}>
          <span class="work-achievement-next-label">${en ? 'Next' : '次は'}「${a.next.title}」</span><span class="mi mi-sm" aria-hidden="true">arrow_forward</span>
        </button>` : nothing}
      </div>
      <button type="button" class="work-achievement-close" aria-label=${close} title=${close} @click=${() => this.emit({ action: 'achievement-close' })}>
        <span class="mi mi-sm" aria-hidden="true">close</span>
      </button>
    </div>`;
  }
}

defineZenComponent('zen-work-achievement', ZenWorkAchievement);
